import React, { useEffect, useState } from 'react';
import { Modal, Descriptions, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import AvatarPicker from '~/components/ImagePicker';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import { Table } from '~/components/Table';
import Pagination from '~/components/Pagination';
import { getEmployees } from '~/services/hooks/employees';
import { teamEmployeeTable } from '~/tables/teamEmployeesTable';

export default function EmployeesModalView({ visible, onClose, employee, isMobile }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [teamEmployee, setTeamEmployee] = useState([]);
  const [pageTeamEmployee, setPageTeamEmployee] = useState(1);
  const [metaTeamEmployee, setMetaTeamEmployee] = useState({});

  const fetchTeamEmployee = async () => {
    setLoading(true);
    try {
      if (employee) {
        const params = {
          params: {
            page: pageTeamEmployee,
          },
        };
        const response = await getEmployees(params, `team-employee/${employee?.id}`);

        setTeamEmployee(response?.data);
        setMetaTeamEmployee(response?.meta);
      }
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      fetchTeamEmployee();
    }
  }, [visible]);

  return (
    <Modal
      title={`${t('Informações')} - ${employee?.name ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      <FormControl>
        <Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <AvatarPicker
            imageUrl={employee?.avatar_url || ''}
            onClick={false}
            width="160px"
            style={{ justifySelf: 'center' }}
          />
        </Col>
      </FormControl>

      <Descriptions bordered column={isMobile ? 1 : 2}>
        <Descriptions.Item
          label={t('fields:employees.name')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.name}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.email')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.email}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.phone')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.phone}
        </Descriptions.Item>

        <Descriptions.Item label={t('fields:employees.address')} span={2}>
          {employee?.address}
        </Descriptions.Item>

        <Descriptions.Item
          label={t('fields:employees.cpf')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.cpf}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.rg')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.rg}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:event.state')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.state_name ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item label={t('fields:event.city')} span={2}>
          {employee?.city?.name ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item
          label={t('fields:employees.work_reference')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.work_reference}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.emergency_name')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.emergency_name}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.emergency_phone')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.emergency_phone}
        </Descriptions.Item>

        <Descriptions.Item
          label={t('fields:employees.bank_name')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.bank_name}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.bank_agency')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.bank_agency}
        </Descriptions.Item>
        <Descriptions.Item label={t('Operação')} labelStyle={{ width: '12%' }} contentStyle={{ width: '25%' }}>
          {employee?.bank_account_operation}
        </Descriptions.Item>

        <Descriptions.Item
          label={t('fields:employees.bank_account_number')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.bank_account_number}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('fields:employees.bank_account_type')}
          labelStyle={{ width: '12%' }}
          contentStyle={{ width: '25%' }}
        >
          {employee?.bank_account_type === 1 ? t('Conta poupança') : t('Conta corrente')}
        </Descriptions.Item>
        <Descriptions.Item label={t('Classificação')} labelStyle={{ width: '12%' }} contentStyle={{ width: '25%' }}>
          {{
            0: t('A'),
            1: t('B'),
            2: t('C'),
          }[employee?.classification] ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item label={t('fields:employees.note')} span={2}>
          {employee?.note}
        </Descriptions.Item>
      </Descriptions>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: 24,
            fontWeight: 600,
            color: '#262626',
            lineHeight: 1.2,
          }}
        >
          {t('Histórico')}
        </p>
      </div>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={teamEmployee}
        columns={teamEmployeeTable(isMobile)}
        bordered
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPageTeamEmployee(value);
        }}
        meta={metaTeamEmployee}
      />
      <div style={{ marginBottom: 40 }}></div>
    </Modal>
  );
}
